import React, { createContext, useCallback, useState } from "react";
import TableContext, { TableContextValues } from "../task/TableContext";

import { useEndpointData } from "../../utils/TableUtils";
import AccountService from "../../services/AccountService";
import { PageDataRequest } from "../account/entities/AccountResponse";

class InvoiceListTableContextValues extends TableContextValues<any> {
  request: any;
  setRequest: any;
}

export const InvoiceListContext = createContext(
  new InvoiceListTableContextValues()
);

const InvoiceListTableProvider = ({
  children,
  prevRequest
}: React.PropsWithChildren<{ prevRequest?: PageDataRequest }>) => {
  const [request, setRequest] = useState(prevRequest);
  const endpoint = useCallback(
    async () => AccountService.getInvoices(request ?? { page: 1 }),
    [request]
  );
  const { loading, response } = useEndpointData(endpoint);
  const applySearch = () => {
    setRequest({ ...request, page: request?.page || 1 });
  };

  const value: InvoiceListTableContextValues = {
    loading,
    error: false,
    response,
    setSortColumn: () => {},
    sort: { sortColumn: "", sortDirection: 0 },
    currentPage: 1,
    setCurrentPage: () => {},
    pageCount: 1,
    applyFilters: () => {},
    applySearch,
    reload: () => {},
    request,
    setRequest,
    pageSize: response?.list.length || 1
  };

  return (
    <TableContext.Provider value={value}>{children}</TableContext.Provider>
  );
};

export default InvoiceListTableProvider;
